export const musicList3 = [
  {
    title: "잊고 있던 좋은 음악",
    id: "forgot1",
    photo: "https://dongsooo.github.io/imgs/img/03_forgot-01.jpg",
    musicTitle: "Bronze -Aquarium",
  },
  {
    id: "forgot2",
    photo: "https://dongsooo.github.io/imgs/img/03_forgot-02.jpg",
    musicTitle: "Nujabes - Aurarian Dance",
  },
  {
    id: "forgot3",
    photo: "https://dongsooo.github.io/imgs/img/03_forgot-03.jpg",
    musicTitle: "Pink Floyd - Money",
  },
  {
    id: "forgot4",
    photo: "https://dongsooo.github.io/imgs/img/03_forgot-04.jpeg",
    musicTitle: "owl city - the mid summer station",
  },
  {
    id: "forgot5",
    photo: "https://dongsooo.github.io/imgs/img/03_forgot-05.jpg",
    musicTitle: "Noel Gallgher - Dead in the water",
  },
];
